import React, { useEffect, Fragment } from "react";
import { Box, Paper, Tabs, Tab } from "@material-ui/core";
import PatientDetailsHeader from "./PatientDetailsHeader";
import PatientDetailsProfile from "./PatientDetailsProfile";
import Axios from "axios";
import Notify from "src/notification/Notify";
import { Folder, User } from "react-feather";
import TabPanel from "src/utils/TabPanel";
import PatientTriageContactTracing from "./PatientTriageContactTracing";

const PatientTriageDetails = ({ patient_id, getIncompleteReg }) => {
	const [category, setCategory] = React.useState(0);
	const [info, setInfo] = React.useState({
		data: null,
		ready: false,
	});

	const getPatientInformation = () => {
		var params = { patient_id: patient_id };
		Axios.get("triage/patient/patient-information", { params })
			.then((response) => {
				const data = response.data;
				setInfo({
					data: data,
					ready: true,
				});
			})
			.catch((error) => {
				Notify.requestError(error);
			});
	};

	const handleChange = (event, newCategory) => {
		event.persist();
		setCategory(newCategory);
	};

	useEffect(() => {
		getPatientInformation();

		// eslint-disable-next-line
	}, [patient_id]);

	return (
		<>
			{info.ready ? (
				<Fragment>
					<PatientDetailsHeader patient_id={patient_id} info={info} />

					<Box mt={2} m={0} p={0}>
						<Box component={Paper} elevation={1} mb={2}>
							<Tabs
								value={category}
								onChange={handleChange}
								indicatorColor="primary"
								textColor="primary"
								variant="scrollable"
								scrollButtons="on"
							>
								<Tab wrapped label="Profile" icon={<User />} />
								<Tab wrapped label="Contact Tracing" icon={<Folder />} />
							</Tabs>
						</Box>

						<TabPanel value={category} index={0}>
							<PatientDetailsProfile
								patient_id={patient_id}
								getIncompleteReg={() => getIncompleteReg()}
								getPatientInformation={getPatientInformation}
								info={info}
							/>
						</TabPanel>

						<TabPanel value={category} index={1}>
							<PatientTriageContactTracing
								patient_id={patient_id}
								getIncompleteReg={() => getIncompleteReg()}
								getPatientInformation={getPatientInformation}
								info={info}
							/>
						</TabPanel>
					</Box>
				</Fragment>
			) : (
				Notify.loading()
			)}
		</>
	);
};

export default PatientTriageDetails;
